import { NgModule } from "@angular/core";
import { TourService } from "./tour.service";

@NgModule({
    providers: [
        TourService
    ]
})
export class TourModule {

}